// Module
var code = "<div class=\"curve-graph\" data-bind=\"if: highchartsOptions\">\r\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}\" class=\"chart\"></div>\r\n</div>\r\n";
// Exports
module.exports = code;